const state = {
    key: "",

}

const mutations = {
    setKey(state, key) {
        state.key = key;
    }
};

const actions = {
    // 异步操作
    getKey({ commit,state }) {
        return state.key
    },

};

const getters = {

};

export default {
    namespaced: true, // 推荐开启命名空间
    state,
    mutations,
    actions,
    getters,
};
